import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {SelectItem} from "primeng/api";

import {AwsService} from "../aws.service";

import {Theme} from "../../api/model/theme";

//const hexoThemes: any = require('./hexo-themes-web.yml');

@Component({
    template: require('./theme-form.component.pug'),
    styles: [require('./theme-form.component.css')]
})
export class ThemeFormComponent implements OnInit {
    action: string = 'create';
    siteId: string;

    model: Theme = {};

    baseThemes: SelectItem[] = [];
    baseSelected: string = 'landscape';

    layouts: string[] = [];

    constructor(private route: ActivatedRoute, private _awsService: AwsService) {
        console.log('[ThemeFormComponent][constructor]');
        this.siteId = localStorage.getItem('currentSite');
        //for (let theme of hexoThemes) {
        //    this.baseThemes.push({label: theme.name, value: theme.link});
        //}
    }

    async ngOnInit() {
        let id = this.route.snapshot.paramMap.get("id");
        if (id !== "new") {
            this.model = (await this._awsService.api.sitesIdThemesThemeIdGet({id: this.siteId, themeId: id})).data;
            this.action = 'update';
        }
    }

    async save() {
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/themes/theme-form.component.ts